import { reject } from 'lodash';
import * as appTypes from './appTypes';

export const setAppLoading = (loading) => ({
  type: appTypes.SET_APP_LOADING,
  loading,
});

//POST APPOINTMENT
export const postAppointmentRequest = (payload) => ({
  type: appTypes.POST_APPOINTMENT_REQUEST,
  payload
})
export const postAppointmentSuccess = (tokenappointment) => ({
  type: appTypes.POST_APPOINTMENT_SUCCESS,
  payload: { data: tokenappointment }
})
export const postAppointmentFailure = (error) => ({
  type: appTypes.POST_APPOINTMENT_FAILURE,
  payload: { error },
})

// GET APPOINTMENT 
export const getAppointmentRequest = ({ token = null, params = {} } = {}, resolve, reject) => ({
  type: appTypes.GET_APPOINTMENT_REQUEST,
  payload: { token, params, resolve, reject }
})
export const getAppointmentSuccess = (data) => ({
  type: appTypes.GET_APPOINTMENT_SUCCESS,
  payload: { data }
})
export const getAppointmentFailure = (error) => ({
  type: appTypes.GET_APPOINTMENT_FAILURE,
  payload: { error }
})
// GET APPOINTMENT BY ID
export const getAppointmentByIdRequest = (appointmentId) => ({
  type: appTypes.GET_APPOINTMENT_BY_ID_REQUEST,
  payload: { appointmentId }
})
export const getAppointmentByIdSuccess = (data) => ({
  type: appTypes.GET_APPOINTMENT_BY_ID_SUCCESS,
  payload: { data }
})
export const getAppointmentByIdFailure = (error) => ({
  type: appTypes.GET_APPOINTMENT_BY_ID_FAILURE,
  payload: { error }
})


//GET Appointment BY PATIENT ID
export const getAppointmentByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_APPOINTMENT_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getAppointmentByPatientIdSuccess = (data) => ({
  type: appTypes.GET_APPOINTMENT_BY_PATIENTID_SUCCESS,
  payload: { data }
})
export const getAppointmentByPatientIdFailure = (error) => ({
  type: appTypes.GET_APPOINTMENT_BY_PATIENTID_FAILURE,
  payload: { error }
})

//POST PATIENT
export const postPatientRequest = (payload) => ({
  type: appTypes.POST_PATIENT_REQUEST,
  payload
})
export const postPatientSuccess = (patient) => ({
  type: appTypes.POST_PATIENT_SUCCESS,
  payload: { data: patient }
})
export const postPatientFailure = (error) => ({
  type: appTypes.POST_PATIENT_FAILURE,
  payload: { error }
})
//  GET PATIENT
// export const getPatientRequest = (token, resolve, reject) => ({
//   type: appTypes.GET_PATIENT_REQUEST,
//   payload: { token, resolve, reject },
// })
export const getPatientRequest = ({ token = null, params = null } = {}, resolve, reject) => ({
  type: appTypes.GET_PATIENT_REQUEST,
  payload: { token, params, resolve, reject }
});
export const getPatientSuccess = (data) => ({
  type: appTypes.GET_PATIENT_SUCCESS,
  payload: { data }
})
export const getPatientFailure = (error) => ({
  type: appTypes.GET_PATIENT_FAILURE,
  payload: { error }
})

//GET PATIENT BY ID
export const getPatientByIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_PATIENT_BY_ID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getPatientByIdSuccess = (data) => ({
  type: appTypes.GET_PATIENT_BY_ID_SUCCESS,
  payload: { data }
})
export const getPatientByIdFailure = (error) => ({
  type: appTypes.GET_PATIENT_BY_ID_FAILURE,
  payload: { error }
})


//GET PATIENTINFO BY PATIENT ID
export const getPatientInfoByIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_PATIENTINFO_BY_ID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getPatientInfoByIdSuccess = (data) => ({
  type: appTypes.GET_PATIENTINFO_BY_ID_SUCCESS,
  payload: { data }
})
export const getPatientInfoByIdFailure = (error) => ({
  type: appTypes.GET_PATIENTINFO_BY_ID_FAILURE,
  payload: { error }
})

//GET TAG BY PATIENT ID
export const getTagByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_TAG_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getTagByPatientIdSuccess = (data) => ({
  type: appTypes.GET_TAG_BY_PATIENT_ID_SUCCESS,
  payload: { data }
})
export const getTagByPatientIdFailure = (error) => ({
  type: appTypes.GET_TAG_BY_PATIENT_ID_FAILURE,
  payload: { error }
})
//GET ALL TAGS
export const getTagsRequest = (token, resolve, reject) => ({
  type: appTypes.GET_TAGS_REQUEST,
  payload: { token, resolve, reject }
})
export const getTagsSuccess = (data) => ({
  type: appTypes.GET_TAGS_SUCCESS,
  payload: { data }
})
export const getTagsFailure = (error) => ({
  type: appTypes.GET_TAGS_FAILURE,
  payload: { error }
})
//GET AREA BY PATIENT ID
export const getAreaByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_AREA_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getAreaByPatientIdSuccess = (data) => ({
  type: appTypes.GET_AREA_BY_PATIENT_ID_SUCCESS,
  payload: { data }
})
export const getAreaByPatientIdFailure = (error) => ({
  type: appTypes.GET_AREA_BY_PATIENT_ID_FAILURE,
  payload: { error }
})
//GET ALL AREAS
export const getAreasRequest = (token, resolve, reject) => ({
  type: appTypes.GET_AREAS_REQUEST,
  payload: { token, resolve, reject }
})
export const getAreasSuccess = (data) => ({
  type: appTypes.GET_AREAS_SUCCESS,
  payload: { data }
})
export const getAreasFailure = (error) => ({
  type: appTypes.GET_AREAS_FAILURE,
  payload: { error }
})
//POST MEDICAL RECORDS
export const postMedicalRecordsRequest = (data, resolve, reject) => ({
  type: appTypes.POST_MEDICALRECORD_REQUEST,
  payload: { data, resolve, reject }
})
export const postMedicalRecordsSuccess = (data) => ({
  type: appTypes.POST_MEDICALRECORD_SUCCESS,
  payload: { data }
})
export const postMedicalRecordsFailure = (error) => ({
  type: appTypes.POST_MEDICALRECORD_FAILURE,
  payload: { error }
})

//GET MEDICAL RECORDS BY  PATIENT ID 

export const getMedicalRecordsRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_MEDICALRECORD_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }

})
export const getMedicalRecordSuccess = (data) => ({
  type: appTypes.GET_MEDICALRECORD_BY_PATIENTID_SUCCESS,
  payload: { data }

})
export const getMedicalRecordFailure = (error) => ({
  type: appTypes.GET_MEDICALRECORD_BY_PATIENTID_FAILURE,
  payload: { error }
})
//GET MEDICAL RECORDS BY MEDICAL ID 

export const getMedicalRecordsByIdRequest = (medicalId, resolve, reject) => ({
  type: appTypes.GET_MEDICALRECORD_BY_ID_REQUEST,
  payload: { medicalId, resolve, reject }
})
export const getMedicalRecordsByIdSuccess = (data) => ({
  type: appTypes.GET_MEDICALRECORD_BY_ID_SUCCESS,
  payload: { data }
})
export const getMedicalRecordsByIdFailure = (error) => ({
  type: appTypes.GET_MEDICALRECORD_BY_ID_FAILURE,
  payload: { error }
})

//POST TEMPLATE
export const postTemplateRequest = (data, resolve, reject) => ({
  type: appTypes.POST_TEMPLATE_REQUEST,
  payload: { data, resolve, reject }
})
export const postTemplateSuccess = (data) => ({
  type: appTypes.POST_TEMPLATE_SUCCESS,
  payload: { data }
})
export const postTemplateFailure = (error) => ({
  type: appTypes.POST_TEMPLATE_FAILURE,
  payload: { error }
})

export const postFollowupRequest = (data, resolve, reject) => ({
  type: appTypes.POST_FOLLOWUP_REQUEST,
  payload: { data, resolve, reject }
})
export const postFollowupSuccess = (data) => ({
  type: appTypes.POST_FOLLOWUP_SUCCESS,
  payload: { data }
})
export const postFollowupFailure = (error) => ({
  type: appTypes.POST_FOLLOWUP_FAILURE,
  payload: { error }
})

export const getFollowupByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_FOLLOWUP_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }

})
export const getFollowupByPatientIdSuccess = (data) => ({
  type: appTypes.GET_FOLLOWUP_BY_PATIENTID_SUCCESS,
  payload: { data }

})
export const getFollowupByPatientIdFailure = (error) => ({
  type: appTypes.GET_FOLLOWUP_BY_PATIENTID_FAILURE,
  payload: { error }
})

//GET TEMPLATE BY CLINIC ID
export const getTemplateByClinicIdRequest = (clinicId, resolve, reject) => ({
  type: appTypes.GET_TEMPLATE_BY_CLINICID_REQUEST,
  payload: { clinicId, resolve, reject }
})
export const getTemplateByClinicIdSuccess = (data) => ({
  type: appTypes.GET_TEMPLATE_BY_CLINICID_SUCCESS,
  payload: { data }
})
export const getTemplateByClinicIdFailure = (error) => ({
  type: appTypes.GET_TEMPLATE_BY_CLINICID_FAILURE,
  payload: { error }
})

//GET CUSTOM FIELDS
export const getCustomFieldsRequest = (clinicId, resolve, reject) => ({
  type: appTypes.GET_CUSTOM_FIELDS_REQUEST,
  payload: { clinicId, resolve, reject }
})
export const getCustomFieldsSuccess = (data) => ({
  type: appTypes.GET_CUSTOM_FIELDS_SUCCESS,
  payload: { data }
})
export const getCustomFieldsFailure = (error) => ({
  type: appTypes.GET_CUSTOM_FIELDS_FAILURE,
  payload: { error }
})

//POST CUSTOM FIELDS
export const postCustomFieldsRequest = (data, resolve, reject) => ({
  type: appTypes.POST_CUSTOM_FIELDS_REQUEST,
  payload: { data, resolve, reject }
})
export const postCustomFieldsSuccess = (data) => ({
  type: appTypes.POST_CUSTOM_FIELDS_SUCCESS,
  payload: { data }
})
export const postCustomFieldsFailure = (error) => ({
  type: appTypes.POST_CUSTOM_FIELDS_FAILURE,
  payload: { error }
})




//DELETE MEDICAL RECORD BY ID
export const deleteMedicalRecordRequest = (id, resolve, reject) => ({
  type: appTypes.DELETE_MEDICALRECORD_BY_ID_REQUEST,
  payload: { id, resolve, reject }

})
export const deleteMedicalRecordSuccess = (id) => ({

  type: appTypes.DELETE_MEDICALRECORD_BY_ID_SUCCESS,
  payload: { id }
})
export const deleteMedicalRecordFailure = (error) => ({
  type: appTypes.DELETE_MEDICALRECORD_BY_ID_FAILURE,
  payload: { error }
})


//UPDATE RECORD STATUS;
export const updateRecordStatusRequest = (appointmentId, data, resolve, reject) => ({
  type: appTypes.UPDATE_STATUS_REQUEST,
  payload: { appointmentId, data, resolve, reject },
})
export const updateRecordStatusSuccess = (data) => ({
  type: appTypes.UPDATE_STATUS_SUCCESS,
  payload: { data }
})
export const updateRecordStatusFailure = (error) => ({
  type: appTypes.UPDATE_STATUS_FAILURE,
  payload: { error }
})



//get Availibity
export const fetchAvailabilityRequest = (clinicId, resolve, reject) => ({
  type: appTypes.FETCH_AVAILABILITY_REQUEST,
  payload: { clinicId, resolve, reject },
});

export const fetchAvailabilitySuccess = (data) => ({
  type: appTypes.FETCH_AVAILABILITY_SUCCESS,
  data,
});

export const fetchAvailabilityFailure = (error) => ({
  type: appTypes.FETCH_AVAILABILITY_FAILURE,
  payload: { error },
});


export const getClinics = () => ({
  type: appTypes.GET_CLINICS,
});

export const setClinics = (data) => ({
  type: appTypes.SET_CLINICS,
  data,
});

export const setCurrentClinics = (data) => ({
  type: appTypes.SET_CURRENT_CLINIC,
  data,
});



//GET BILLINGS BY PATIENT ID
export const getBillingsByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_BILLINGS_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getBillingsByPatientIdSuccess = (data) => ({
  type: appTypes.GET_BILLINGS_BY_PATIENTID_SUCCESS,
  payload: { data }
})
export const getBillingsByPatientIdFailure = (error) => ({
  type: appTypes.GET_BILLINGS_BY_PATIENTID_FAILURE,
  payload: { error }
})
//POST MESSAGE 
export const postMessageRequest = (data, resolve, reject) => ({
  type: appTypes.POST_MESSAGE_REQUEST,
  payload: { data, resolve, reject }
})
export const postMessageSuccess = (data) => ({
  type: appTypes.POST_MESSAGE_SUCCESS,
  payload: { data }
})
export const postMessageFailure = (error) => ({
  type: appTypes.POST_MESSAGE_FAILURE,
  payload: { error }
})
//GET MESSAGE BY PATIENT ID
export const getMessageByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_MESSAGE_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getMessageByPatientByIdSuccess = (data) => ({
  type: appTypes.GET_MESSAGE_BY_PATIENTID_SUCCESS,
  payload: { data }
})
export const getMessageByPatientIdFailure = (error) => ({
  type: appTypes.GET_MESSAGE_BY_PATIENTID_FAILURE,
  payload: { error }
})
//DELETE MESSAGE BY ID
export const deleteMessageByIdRequest = (id, resolve, reject) => ({
  type: appTypes.DELETE_MESSAGE_BY_ID_REQUEST,
  payload: { id, resolve, reject }
})
export const deleteMessageByIdSuccess = (id) => ({
  type: appTypes.DELETE_MESSAGE_BY_ID_SUCCESS,
  payload: { id }

})
export const deleteMessageByIdFailure = (error) => ({
  type: appTypes.DELETE_MESSAGE_BY_ID_FAILURE,
  payload: { error }
})


//GET REPORT BY PATIENT ID 
export const getReportsByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_REPORT_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getReportsByPatientIdSuccess = (data) => ({
  type: appTypes.GET_REPORT_BY_PATIENTID_SUCCESS,
  payload: { data }
})
export const getReportsByPatientIdFailure = (error) => ({
  type: appTypes.GET_REPORT_BY_PATIENTID_FAILURE,
  payload: { error }
})

//GET REPORT VIEW BY ID
export const getViewReportByIdRequest = (reportId, resolve, reject) => ({
  type: appTypes.GET_VIEWREPORT_BY_ID_REQUEST,
  payload: { reportId, resolve, reject }
})
export const getViewReportByIdSuccess = (data) => ({
  type: appTypes.GET_VIEWREPORT_BY_ID_SUCCESS,
  payload: { data }
})
export const getViewReportByIdFailure = (error) => ({
  type: appTypes.GET_VIEWREPORT_BY_ID_FAILURE,
  payload: { error }
})

//GET REPORT DOWNLOAD BY ID
export const getDownloadReportByIdRequest = (downloadId, resolve, reject) => ({
  type: appTypes.GET_DOWNLOADREPORT_BY_ID_REQUEST,
  payload: { downloadId, resolve, reject }
})
export const getDownloadReportByIdSuccess = (data) => ({
  type: appTypes.GET_DOWNLOADREPORT_BY_ID_SUCCESS,
  payload: { data }
})
export const getDownloadReportByIdFailure = (error) => ({
  type: appTypes.GET_DOWNLOADREPORT_BY_ID_FAILURE,
  payload: { error }
})

//GET TREATMENT BY PATIENT ID
export const getTreatmentsByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_TREATMENT_BY_PATIENTID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getTreatmentsByPatientIdSuccess = (data) => ({
  type: appTypes.GET_TREATMENT_BY_PATIENTID_SUCCESS,
  payload: { data }
})
export const getTreatmentsByPatientIdFailure = (error) => ({
  type: appTypes.GET_TREATMENT_BY_PATIENTID_FAILURE,
  payload: { error }
})

// GET Treatment BY ID
export const getTreatmentByIdRequest = (treatmentId, resolve, reject) => ({
  type: appTypes.GET_TREATMENT_BY_ID_REQUEST,
  payload: { treatmentId, resolve, reject }
})
export const getTreatmentByIdSuccess = (data) => ({
  type: appTypes.GET_TREATMENT_BY_ID_SUCCESS,
  payload: { data }
})
export const getTreatmentByIdFailure = (error) => ({
  type: appTypes.GET_TREATMENT_BY_ID_FAILURE,
  payload: { error }
})

//POST DOCTOR PROFILE 
export const postDoctorProfileRequest = (data, resolve, reject) => ({
  type: appTypes.POST_DOCTORPROFILE_REQUEST,
  payload: { data, resolve, reject }
})
export const postDoctorProfileSuccess = (data) => ({
  type: appTypes.POST_DOCTORPROFILE_SUCCESS,
  payload: { data }
})
export const postDoctorProfileFailure = (error) => ({
  type: appTypes.POST_DOCTORPROFILE_FAILURE,
  payload: { error }
})



//GET DOCTOR PROFILE BY ID
export const getDoctorProfileByIdRequest = (doctId, resolve, reject) => ({
  type: appTypes.GET_DOCTORPROFILE_BY_ID_REQUEST,
  payload: { doctId, resolve, reject }
})
export const getDoctorProfileByIdSuccess = (data) => ({
  type: appTypes.GET_DOCTORPROFILE_BY_ID_SUCCESS,
  payload: { data }
})
export const getDoctorProfileByIdFailure = (error) => ({
  type: appTypes.GET_DOCTORPROFILE_BY_ID_FAILURE,
  payload: { error }
})




//POST CLINIC PROFILE 
export const postClinicProfileRequest = (data, resolve, reject) => ({
  type: appTypes.POST_CLINICPROFILE_REQUEST,
  payload: { data, resolve, reject }
})
export const postClinicProfileSuccess = (data) => ({
  type: appTypes.POST_CLINICPROFILE_SUCCESS,
  payload: { data }
})
export const postClinicProfileFailure = (error) => ({
  type: appTypes.POST_CLINICPROFILE_FAILURE,
  payload: { error }
})


//GET CLINIC PROFILE BY ID
export const getClinicProfileByIdRequest = (clinicId, resolve, reject) => ({
  type: appTypes.GET_CLINICPROFILE_BY_ID_REQUEST,
  payload: { clinicId, resolve, reject }
})
export const getClinicProfileByIdSuccess = (data) => ({
  type: appTypes.GET_CLINICPROFILE_BY_ID_SUCCESS,
  payload: { data }
})
export const getClinicProfileByIdFailure = (error) => ({
  type: appTypes.GET_CLINICPROFILE_BY_ID_FAILURE,
  payload: { error }
})
//UPDATE PATIENT DATA BY ID 
export const updatePatientByIdRequest = (patientId, data, resolve, reject) => ({
  type: appTypes.UPDATE_PATIENT_BY_ID_REQUEST,
  payload: { patientId, data, resolve, reject },
})
export const updatePatientByIdSuccess = (data) => ({
  type: appTypes.UPDATE_PATIENT_BY_ID_SUCCESS,
  payload: { data }
})
export const updatePatientByIdFailure = (error) => ({
  type: appTypes.UPDATE_PATIENT_BY_ID_FAILURE,
  payload: { error }
})
//UPDATE PATIENTINFO DATA BY ID 
export const updatePatientInfoByIdRequest = (infoId, data, resolve, reject) => ({
  type: appTypes.UPDATE_PATIENTINFO_BY_ID_REQUEST,
  payload: { infoId, data, resolve, reject },
})
export const updatePatientInfoByIdSuccess = (data) => ({
  type: appTypes.UPDATE_PATIENTINFO_BY_ID_SUCCESS,
  payload: { data }
})
export const updatePatientInfoByIdFailure = (error) => ({
  type: appTypes.UPDATE_PATIENTINFO_BY_ID_FAILURE,
  payload: { error }
})
//UPDATE AREA DATA BY ID 
export const updateAreaByIdReuest = (areaId, data, resolve, reject) => ({
  type: appTypes.UPDATE_AREA_BY_ID_REQUEST,
  payload: { areaId, data, resolve, reject },
})
export const updateAreaByIdSuccess = (data) => ({
  type: appTypes.UPDATE_AREA_BY_ID_SUCCESS,
  payload: { data }
})
export const updateAreaByIdFailure = (error) => ({
  type: appTypes.UPDATE_AREA_BY_ID_FAILURE,
  payload: { error }
})
//UPDATE TAG DATA BY ID 
export const updateTagByIdReuest = (tagId, data, resolve, reject) => ({
  type: appTypes.UPDATE_TAG_BY_ID_REQUEST,
  payload: { tagId, data, resolve, reject },
})
export const updateTagByIdSuccess = (data) => ({
  type: appTypes.UPDATE_TAG_BY_ID_SUCCESS,
  payload: { data }
})
export const updateTagByIdFailure = (error) => ({
  type: appTypes.UPDATE_TAG_BY_ID_FAILURE,
  payload: { error }
})

//POST AREA
export const postAreaRequest = (data, resolve, reject) => ({
  type: appTypes.POST_AREA_REQUEST,
  payload: { data, resolve, reject }
})
export const postAreaSuccess = (data) => ({
  type: appTypes.POST_AREA_SUCCESS,
  payload: { data }
})
export const postAreaFailure = (error) => ({
  type: appTypes.POST_AREA_FAILURE,
  payload: { error }
})

//POST TAG
export const postTagRequest = (data, resolve, reject) => ({
  type: appTypes.POST_TAG_REQUEST,
  payload: { data, resolve, reject }
})
export const postTagSuccess = (data) => ({
  type: appTypes.POST_TAG_SUCCESS,
  payload: { data }
})
export const postTagFailure = (error) => ({
  type: appTypes.POST_TAG_FAILURE,
  payload: { error }
})

//POST PATIENT INFO
export const postPatientInfoRequest = (data, resolve, reject) => ({
  type: appTypes.POST_PATIENTINFO_REQUEST,
  payload: { data, resolve, reject }
})
export const postPatientInfoSuccess = (data) => ({
  type: appTypes.POST_PATIENTINFO_SUCCESS,
  payload: { data }
})
export const postPatientInfoFailure = (error) => ({
  type: appTypes.POST_PATIENTINFO_FAILURE,
  payload: { error }
})

//POST TREATMENT
export const postTreatmentRequest = (data, resolve, reject) => ({
  type: appTypes.POST_TREATMENT_REQUEST,
  payload: { data, resolve, reject }
})
export const postTreatmentSuccess = (data) => ({
  type: appTypes.POST_TREATMENT_SUCCESS,
  payload: { data }
})
export const postTreatmentFailure = (error) => ({
  type: appTypes.POST_TREATMENT_FAILURE,
  payload: { error }
})

//POST BILLING
export const postBillingRequest = (data, resolve, reject) => ({
  type: appTypes.POST_BILLING_REQUEST,
  payload: { data, resolve, reject }
})
export const postBillingSuccess = (data) => ({
  type: appTypes.POST_BILLING_SUCCESS,
  payload: { data }
})
export const postBillingFailure = (error) => ({
  type: appTypes.POST_BILLING_FAILURE,
  payload: { error }
})

//POST UPLOAD
export const postUploadRequest = (data, resolve, reject) => {
  return {
    type: appTypes.POST_UPLOAD_REQUEST,
    payload: { data, resolve, reject }
  };
};

export const postUploadSuccess = (data) => {
  return {
    type: appTypes.POST_UPLOAD_SUCCESS,
    payload: { data }
  };
};

export const postUploadFailure = (error) => {
  return {
    type: appTypes.POST_UPLOAD_FAILURE,
    payload: { error }
  };
};

//POST LOGO
export const postUploadLogoRequest = (data, resolve, reject) => {
  return {
    type: appTypes.POST_UPLOADLOGO_REQUEST,
    payload: { data, resolve, reject }
  };
};

export const postUploadLogoSuccess = (data) => {
  return {
    type: appTypes.POST_UPLOADLOGO_SUCCESS,
    payload: { data }
  };
};

export const postUploadLogoFailure = (error) => {
  return {
    type: appTypes.POST_UPLOADLOGO_FAILURE,
    payload: { error }
  };
};

//POST PROFILEPIC
export const postProfilePicRequest = (data, resolve, reject) => {
  return {
    type: appTypes.POST_PROFILEPIC_REQUEST,
    payload: { data, resolve, reject }
  };
};

export const postProfilePicSuccess = (data) => {
  return {
    type: appTypes.POST_PROFILEPIC_SUCCESS,
    payload: { data }
  };
};

export const postProfilePicFailure = (error) => {
  return {
    type: appTypes.POST_PROFILEPIC_FAILURE,
    payload: { error }
  };
};

//POST STAFF
export const postStaffRequest = (data, resolve, reject) => ({
  type: appTypes.POST_STAFF_REQUEST,
  payload: { data, resolve, reject }
})
export const postStaffSuccess = (data) => ({
  type: appTypes.POST_STAFF_SUCCESS,
  payload: { data }
})
export const postStaffFailure = (error) => ({
  type: appTypes.POST_STAFF_FAILURE,
  payload: { error }
})

//GET STAFF
export const getStaffRequest = ({ token, params } = {}, resolve, reject) => ({
  type: appTypes.GET_STAFF_REQUEST,
  payload: { token, params, resolve, reject }
})
export const getStaffSuccess = (data) => ({
  type: appTypes.GET_STAFF_SUCCESS,
  payload: { data }
})
export const getStaffFailure = (error) => ({
  type: appTypes.GET_STAFF_FAILURE,
  payload: { error }
})

//POST CLINIC
export const postClinicRequest = (data, resolve, reject) => ({
  type: appTypes.POST_CLINIC_REQUEST,
  payload: { data, resolve, reject }
})
export const postClinicSuccess = (data) => ({
  type: appTypes.POST_CLINIC_SUCCESS,
  payload: { data }
})
export const postClinicFailure = (error) => ({
  type: appTypes.POST_CLINIC_FAILURE,
  payload: { error }
})
//GET CLINIC
export const getClinicRequest = (token, resolve, reject) => ({
  type: appTypes.GET_CLINIC_REQUEST,
  payload: { token, resolve, reject }
})
export const getClinicSuccess = (data) => ({
  type: appTypes.GET_CLINIC_SUCCESS,
  payload: { data }
})
export const getClinicFailure = (error) => ({
  type: appTypes.GET_CLINIC_FAILURE,
  payload: { error }
})

//GET CLINIC BY ID
export const getClinicByIdRequest = (clinicId, resolve, reject) => ({
  type: appTypes.GET_CLINIC_BY_ID_REQUEST,
  payload: { clinicId, resolve, reject }
})
export const getClinicByIdSuccess = (data) => ({
  type: appTypes.GET_CLINIC_BY_ID_SUCCESS,
  payload: { data }
})
export const getClinicByIdFailure = (error) => ({
  type: appTypes.GET_CLINIC_BY_ID_FAILURE,
  payload: { error }
})

//UPDATE CLINIC DATA BY ID 
export const updateClinicByIdRequest = (clinicId, data, resolve, reject) => ({
  type: appTypes.UPDATE_CLINIC_BY_ID_REQUEST,
  payload: { clinicId, data, resolve, reject },
})
export const updateClinicByIdSuccess = (data) => ({
  type: appTypes.UPDATE_CLINIC_BY_ID_SUCCESS,
  payload: { data }
})
export const updateClinicByIdFailure = (error) => ({
  type: appTypes.UPDATE_CLINIC_BY_ID_FAILURE,
  payload: { error }
})

//GET PATIENT HISTORY BY PATIENT ID
export const getPatientHistoryByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject }
})
export const getPatientHistoryByPatientIdSuccess = (data) => ({
  type: appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_SUCCESS,
  payload: { data }
})
export const getPatientHistoryByPatientIdFailure = (error) => ({
  type: appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_FAILURE,
  payload: { error }
})

//POST TASK
export const postTaskRequest = (data, resolve, reject) => ({
  type: appTypes.POST_TASK_REQUEST,
  payload: { data, resolve, reject }
})
export const postTaskSuccess = (data) => ({
  type: appTypes.POST_TASK_SUCCESS,
  payload: { data }
})
export const postTaskFailure = (error) => ({
  type: appTypes.POST_TASK_FAILURE,
  payload: { error }
})


//GET TASKS
export const getTaskRequest = (token, resolve, reject) => ({
  type: appTypes.GET_TASK_REQUEST,
  payload: { token, resolve, reject }
})
export const getTaskSuccess = (data) => ({
  type: appTypes.GET_TASK_SUCCESS,
  payload: { data }
})
export const getTaskFailure = (error) => ({
  type: appTypes.GET_TASK_FAILURE,
  payload: { error }
})

//POST TASK BY TASK ID


export const postTaskCommentByTaskIdReuest = (taskId, data, resolve, reject) => ({
  type: appTypes.POST_TASKCOMMENT_BY_TASKID_REQUEST,
  payload: { taskId, data, resolve, reject },
})
export const postTaskCommentByTaskIdSuccess = (data) => ({
  type: appTypes.POST_TASKCOMMENT_BY_TASKID_SUCCESS,
  payload: { data }
})
export const postTaskCommentByTaskIdFailure = (error) => ({
  type: appTypes.POST_TASKCOMMENT_BY_TASKID_FAILURE,
  payload: { error }
})

//GET BILLINGS
export const getBillingRequest = ({ token = null, params = null } = {}, resolve, reject) => ({
  type: appTypes.GET_BILLING_REQUEST,
  payload: { token, params, resolve, reject }
})
export const getBillingSuccess = (data) => ({
  type: appTypes.GET_BILLING_SUCCESS,
  payload: { data }
})
export const getBillingFailure = (error) => ({
  type: appTypes.GET_BILLING_FAILURE,
  payload: { error }
})

export const getSummaryRequest = (token, resolve, reject) => ({
  type: appTypes.GET_SUMMARY_REQUEST,
  payload: { token, resolve, reject }
})
export const getSummarySuccess = (data) => ({
  type: appTypes.GET_SUMMARY_SUCCESS,
  payload: { data }
})
export const getSummaryFailure = (error) => ({
  type: appTypes.GET_SUMMARY_FAILURE,
  payload: { error }
})

export const getGoogleAuthUrlRequest = (token, resolve, reject) => ({
  type: appTypes.GET_GOOGLE_AUTH_URL_REQUEST,
  payload: { token, resolve, reject },
});

export const getGoogleAuthUrlSuccess = (data) => ({
  type: appTypes.GET_GOOGLE_AUTH_URL_SUCCESS,
  payload: { data },
});

export const getGoogleAuthUrlFailure = (error) => ({
  type: appTypes.GET_GOOGLE_AUTH_URL_FAILURE,
  payload: { error },
});

export const getSummaryStatRequest = (token, resolve, reject) => ({
  type: appTypes.GET_SUMMARYSTAT_REQUEST,
  payload: { token, resolve, reject }
})
export const getSummaryStatSuccess = (data) => ({
  type: appTypes.GET_SUMMARYSTAT_SUCCESS,
  payload: { data }
})
export const getSummaryStatFailure = (error) => ({
  type: appTypes.GET_SUMMARYSTAT_FAILURE,
  payload: { error }
})

export const getMonthlyAppointmentsRequest = (token, resolve, reject) => ({
  type: appTypes.GET_MONTHLYAPPOINTMENT_REQUEST,
  payload: { token, resolve, reject }
})
export const getMonthlyAppointmentsSuccess = (data) => ({
  type: appTypes.GET_MONTHLYAPPOINTMENT_SUCCESS,
  payload: { data }
})
export const getMonthlyAppointmentsFailure = (error) => ({
  type: appTypes.GET_MONTHLYAPPOINTMENT_FAILURE,
  payload: { error }
})

export const getTaskOverviewRequest = (token, resolve, reject) => ({
  type: appTypes.GET_TASKOVERVIEW_REQUEST,
  payload: { token, resolve, reject }
})
export const getTaskOverviewSuccess = (data) => ({
  type: appTypes.GET_TASKOVERVIEW_SUCCESS,
  payload: { data }
})
export const getTaskOverviewFailure = (error) => ({
  type: appTypes.GET_TASKOVERVIEW_FAILURE,
  payload: { error }
})

export const getAppointmentStatusSummaryRequest = (token, resolve, reject) => ({
  type: appTypes.GET_APPOINTMENTSTATUSSUMMARY_REQUEST,
  payload: { token, resolve, reject }
})
export const getAppointmentStatusSummarySuccess = (data) => ({
  type: appTypes.GET_APPOINTMENTSTATUSSUMMARY_SUCCESS,
  payload: { data }
})
export const getAppointmentStatusSummaryFailure = (error) => ({
  type: appTypes.GET_APPOINTMENTSTATUSSUMMARY_FAILURE,
  payload: { error }
})

export const getTransactionsRequest = (token, resolve, reject) => ({
  type: appTypes.GET_TRANSACTIONS_REQUEST,
  payload: { token, resolve, reject }
})
export const getTransactionsSuccess = (data) => ({
  type: appTypes.GET_TRANSACTIONS_SUCCESS,
  payload: { data }
})
export const getTransactionsFailure = (error) => ({
  type: appTypes.GET_TRANSACTIONS_FAILURE,
  payload: { error }
})

export const getPendingTransactionsRequest = (token, resolve, reject) => ({
  type: appTypes.GET_PENDINGTRANSACTIONS_REQUEST,
  payload: { token, resolve, reject }
})
export const getPendingTransactionsSuccess = (data) => ({
  type: appTypes.GET_PENDINGTRANSACTIONS_SUCCESS,
  payload: { data }
})
export const getPendingTransactionsFailure = (error) => ({
  type: appTypes.GET_PENDINGTRANSACTIONS_FAILURE,
  payload: { error }
})

export const getAvgEarningAndFollowUpRateRequest = (token, resolve, reject) => ({
  type: appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_REQUEST,
  payload: { token, resolve, reject }
})
export const getAvgEarningAndFollowUpRateSuccess = (data) => ({
  type: appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_SUCCESS,
  payload: { data }
})
export const getAvgEarningAndFollowUpRateFailure = (error) => ({
  type: appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_FAILURE,
  payload: { error }
})

//UPDATE AVAILABILITY
export const postAvailabilityRequest = (data, resolve, reject) => ({
  type: appTypes.POST_AVAILABILITY_REQUEST,
  payload: { data, resolve, reject }
})
export const postAvailabilitySuccess = (data) => ({
  type: appTypes.POST_AVAILABILITY_SUCCESS,
  payload: { data }
})
export const postAvailabilityFailure = (error) => ({
  type: appTypes.POST_AVAILABILITY_FAILURE,
  payload: { error },
})


//get Billing By Id
export const getBillingByIdRequest = (billingId, resolve, reject) => ({
  type: appTypes.GET_BILLING_BY_ID_REQUEST,
  payload: { billingId, resolve, reject },
});

export const getBillingByIdSuccess = (data) => ({
  type: appTypes.GET_BILLING_BY_ID_SUCCESS,
  data,
});

export const getBillingByIdFailure = (error) => ({
  type: appTypes.GET_BILLING_BY_ID_FAILURE,
  payload: { error },
});

export const getAvailableSlotsRequest = ({ token = null, params = null } = {}, resolve, reject) => ({
  type: appTypes.GET_AVAILABLE_SLOTS_REQUEST,
  payload: { token, params, resolve, reject },
});

export const getAvailableSlotsSuccess = (data) => ({
  type: appTypes.GET_AVAILABLE_SLOTS_SUCCESS,
  payload: { data },
});

export const getAvailableSlotsFailure = (error) => ({
  type: appTypes.GET_AVAILABLE_SLOTS_FAILURE,
  payload: { error },
});

export const patientLookupRequest = (phone, resolve, reject) => ({
  type: appTypes.PATIENT_LOOKUP_REQUEST,
  payload: { phone, resolve, reject },
});

export const patientLookupSuccess = (data) => ({
  type: appTypes.PATIENT_LOOKUP_SUCCESS,
  payload: { data },
});

export const patientLookupFailure = (error) => ({
  type: appTypes.PATIENT_LOOKUP_FAILURE,
  payload: { error },
});

// GET ALL DOCTORS
export const getAllDoctorsRequest = (resolve, reject) => ({
  type: appTypes.GET_ALL_DOCTORS_REQUEST,
  payload: { resolve, reject }
});

export const getAllDoctorsSuccess = (data) => ({
  type: appTypes.GET_ALL_DOCTORS_SUCCESS,
  payload: { data }
});

export const getAllDoctorsFailure = (error) => ({
  type: appTypes.GET_ALL_DOCTORS_FAILURE,
  payload: { error }
});

// STAFF & VIEW PROFILE ACTIONS
export const SelectedPatient = (payload) => ({
  type: appTypes.SET_SELECTED_PATIENT,
  payload,
});

export const fetchTokenAppointmentRequest = (token, arg2 = 1, arg3 = 50, arg4, arg5) => {
  let page = 1;
  let perPage = 50;
  let resolve;
  let reject;

  if (typeof arg2 === 'function') {
    resolve = arg2;
    reject = arg3;
  } else {
    if (typeof arg2 === 'number') page = arg2;
    if (typeof arg3 === 'number') perPage = arg3;
    resolve = arg4;
    reject = arg5;
  }

  return {
    type: appTypes.FETCH_TOKENAPPOINTMENT_REQUEST,
    payload: { token, page, perPage, resolve, reject },
  };
};

export const fetchTokenAppointmentSuccess = (data) => ({
  type: appTypes.FETCH_TOKENAPPOINTMENT_SUCCESS,
  payload: data,
});

export const fetchTokenAppointmentFailure = (error) => ({
  type: appTypes.FETCH_TOKENAPPOINTMENT_FAILURE,
  payload: error,
});

export const fetchPatientsRequest = (token, arg2 = 1, arg3 = 50, arg4, arg5) => {
  let page = 1;
  let perPage = 50;
  let resolve;
  let reject;

  if (typeof arg2 === 'function') {
    resolve = arg2;
    reject = arg3;
  } else {
    if (typeof arg2 === 'number') page = arg2;
    if (typeof arg3 === 'number') perPage = arg3;
    resolve = arg4;
    reject = arg5;
  }

  return {
    type: appTypes.FETCH_PATIENTS_REQUEST,
    payload: { token, page, perPage, resolve, reject },
  };
};

export const fetchPatientsSuccess = (data) => ({
  type: appTypes.FETCH_PATIENTS_SUCCESS,
  payload: data,
});

export const fetchPatientsFailure = (error) => ({
  type: appTypes.FETCH_PATIENTS_FAILURE,
  payload: error,
});

export const fetchTasksRequest = (token, arg2 = 1, arg3 = 50, arg4, arg5) => {
  let page = 1;
  let perPage = 50;
  let resolve;
  let reject;

  if (typeof arg2 === 'function') {
    resolve = arg2;
    reject = arg3;
  } else {
    if (typeof arg2 === 'number') page = arg2;
    if (typeof arg3 === 'number') perPage = arg3;
    resolve = arg4;
    reject = arg5;
  }

  return {
    type: appTypes.FETCH_TASKS_REQUEST,
    payload: { token, page, perPage, resolve, reject },
  };
};

export const fetchTasksSuccess = (data) => ({
  type: appTypes.FETCH_TASKS_SUCCESS,
  payload: data,
});

export const fetchTasksFailure = (error) => ({
  type: appTypes.FETCH_TASKS_FAILURE,
  payload: error,
});

export const updateTaskStatusRequest = (taskId, status, resolve, reject) => ({
  type: appTypes.UPDATE_TASK_STATUS_REQUEST,
  payload: { taskId, status, resolve, reject },
});

export const updateTaskStatusSuccess = (task) => ({
  type: appTypes.UPDATE_TASK_STATUS_SUCCESS,
  payload: task,
});

export const updateTaskStatusFailure = (error) => ({
  type: appTypes.UPDATE_TASK_STATUS_FAILURE,
  payload: error,
});

export const addCommentRequest = (taskId, data, resolve, reject) => ({
  type: appTypes.ADD_COMMENT_REQUEST,
  payload: { taskId, data, resolve, reject },
});

export const addCommentSuccess = (data) => ({
  type: appTypes.ADD_COMMENT_SUCCESS,
  payload: data,
});

export const addCommentFailure = (error) => ({
  type: appTypes.ADD_COMMENT_FAILURE,
  payload: error,
});

export const fetchStaffsRequest = (clinicIdOrResolve, resolveOrReject, rejectOnly) => {
  let clinicId = null;
  let resolve = null;
  let reject = null;

  if (typeof clinicIdOrResolve === 'string') {
    clinicId = clinicIdOrResolve;
    resolve = resolveOrReject;
    reject = rejectOnly;
  } else if (typeof clinicIdOrResolve === 'function') {
    resolve = clinicIdOrResolve;
    reject = resolveOrReject;
  } else if (clinicIdOrResolve && typeof clinicIdOrResolve === 'object') {
    clinicId = clinicIdOrResolve.clinicId;
    resolve = resolveOrReject;
    reject = rejectOnly;
  }

  return {
    type: appTypes.FETCH_STAFFS_REQUEST,
    payload: { clinicId, resolve, reject },
  };
};

export const fetchStaffsSuccess = (data) => ({
  type: appTypes.FETCH_STAFFS_SUCCESS,
  payload: data,
});

export const fetchStaffsFailure = (error) => ({
  type: appTypes.FETCH_STAFFS_FAILURE,
  payload: error,
});

export const fetchMedicalRecordByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.FETCH_MEDICALRECORD_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject },
});

export const fetchMedicalRecordByPatientIdSuccess = (data) => ({
  type: appTypes.FETCH_MEDICALRECORD_BY_PATIENT_ID_SUCCESS,
  payload: data,
});

export const fetchMedicalRecordByPatientIdFailure = (error) => ({
  type: appTypes.FETCH_MEDICALRECORD_BY_PATIENT_ID_FAILURE,
  payload: error,
});

export const fetchBillingByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.FETCH_BILLING_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject },
});

export const fetchBillingByPatientIdSuccess = (data) => ({
  type: appTypes.FETCH_BILLING_BY_PATIENT_ID_SUCCESS,
  payload: data,
});

export const fetchBillingByPatientIdFailure = (error) => ({
  type: appTypes.FETCH_BILLING_BY_PATIENT_ID_FAILURE,
  payload: error,
});

export const fetchFollowupByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.FETCH_FOLLOWUP_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject },
});

export const fetchFollowupByPatientIdSuccess = (data) => ({
  type: appTypes.FETCH_FOLLOWUP_BY_PATIENT_ID_SUCCESS,
  payload: data,
});

export const fetchFollowupByPatientIdFailure = (error) => ({
  type: appTypes.FETCH_FOLLOWUP_BY_PATIENT_ID_FAILURE,
  payload: error,
});

export const fetchTreatmentByPatientIdRequest = (patientId, resolve, reject) => ({
  type: appTypes.FETCH_TREATMENT_BY_PATIENT_ID_REQUEST,
  payload: { patientId, resolve, reject },
});

export const fetchTreatmentByPatientIdSuccess = (data) => ({
  type: appTypes.FETCH_TREATMENT_BY_PATIENT_ID_SUCCESS,
  payload: data,
});

export const fetchTreatmentByPatientIdFailure = (error) => ({
  type: appTypes.FETCH_TREATMENT_BY_PATIENT_ID_FAILURE,
  payload: error,
});

// UPDATE STAFF
export const updateStaffRequest = (staffId, staffData, resolve, reject) => ({
  type: appTypes.UPDATE_STAFF_REQUEST,
  payload: { staffId, staffData, resolve, reject },
});

export const updateStaffSuccess = (data) => ({
  type: appTypes.UPDATE_STAFF_SUCCESS,
  payload: data,
});

export const updateStaffFailure = (error) => ({
  type: appTypes.UPDATE_STAFF_FAILURE,
  payload: error,
});

// ADD PATIENT (STAFF MODAL)
export const addPatientRequest = (data, resolve, reject) => ({
  type: appTypes.ADD_PATIENT_REQUEST,
  payload: { data, resolve, reject },
});

export const addPatientSuccess = (data) => ({
  type: appTypes.ADD_PATIENT_SUCCESS,
  payload: { data },
});

export const addPatientFailure = (error) => ({
  type: appTypes.ADD_PATIENT_FAILURE,
  payload: { error },
});

// ADD TASK (STAFF MODAL)
export const addTaskRequest = (data, resolve, reject) => ({
  type: appTypes.ADD_TASK_REQUEST,
  payload: { data, resolve, reject },
});

export const addTaskSuccess = (data) => ({
  type: appTypes.ADD_TASK_SUCCESS,
  data,
});

export const addTaskFailure = (error) => ({
  type: appTypes.ADD_TASK_FAILURE,
  payload: { error },
});

// ADD TOKEN APPOINTMENT (STAFF MODAL)
export const addTokenAppointmentRequest = (data, resolve, reject) => ({
  type: appTypes.ADD_TOKENAPPOINTMENT_REQUEST,
  payload: { data, resolve, reject },
});

export const addTokenAppointmentSuccess = (data) => ({
  type: appTypes.ADD_TOKENAPPOINTMENT_SUCCESS,
  payload: { data },
});

export const addTokenAppointmentFailure = (error) => ({
  type: appTypes.ADD_TOKENAPPOINTMENT_FAILURE,
  payload: { error },
});

// ADD BILLING (STAFF MODAL)
export const addBillingRequest = (data, resolve, reject) => ({
  type: appTypes.ADD_BILLING_REQUEST,
  payload: { data, resolve, reject },
});

export const addBillingSuccess = (data) => ({
  type: appTypes.ADD_BILLING_SUCCESS,
  payload: { data },
});

export const addBillingFailure = (error) => ({
  type: appTypes.ADD_BILLING_FAILURE,
  payload: { error },
});

// FETCH PATIENT NAME
export const fetchPatientNameRequest = (resolve, reject) => ({
  type: appTypes.FETCH_PATIENTNAME_REQUEST,
  payload: { resolve, reject },
});
export const fetchPatientnameRequest = fetchPatientNameRequest;

export const fetchPatientNameSuccess = (data) => ({
  type: appTypes.FETCH_PATIENTNAME_SUCCESS,
  payload: data,
});

export const fetchPatientNameFailure = (error) => ({
  type: appTypes.FETCH_PATIENTNAME_FAILURE,
  payload: error,
});

// FETCH DOCTOR PROFILE BY ID
export const fetchDoctorProfileByIdRequest = (id, resolve, reject) => ({
  type: appTypes.FETCH_DOCTORPROFILE_BY_ID_REQUEST,
  payload: { id, resolve, reject },
});

export const fetchDoctorProfileByIdSuccess = (data) => ({
  type: appTypes.FETCH_DOCTORPROFILE_BY_ID_SUCCESS,
  payload: data,
});

export const fetchDoctorProfileByIdFailure = (error) => ({
  type: appTypes.FETCH_DOCTORPROFILE_BY_ID_FAILURE,
  payload: error,
});

// FETCH PROFILE
export const fetchProfileRequest = (resolve, reject) => ({
  type: appTypes.FETCH_PROFILE_REQUEST,
  payload: { resolve, reject },
});

export const fetchProfileSuccess = (data) => ({
  type: appTypes.FETCH_PROFILE_SUCCESS,
  data,
});

export const fetchProfileFailure = (error) => ({
  type: appTypes.FETCH_PROFILE_FAILURE,
  payload: error,
});

// FETCH CLINIC PROFILE BY ID
export const fetchClinicProfileByIdRequest = (id, resolve, reject) => ({
  type: appTypes.FETCH_CLINICPROFILE_BY_ID_REQUEST,
  payload: { id, resolve, reject },
});

export const fetchClinicProfileByIdSuccess = (data) => ({
  type: appTypes.FETCH_CLINICPROFILE_BY_ID_SUCCESS,
  payload: data,
});

export const fetchClinicProfileByIdFailure = (error) => ({
  type: appTypes.FETCH_CLINICPROFILE_BY_ID_FAILURE,
  payload: error,
});

// DELETE TOKEN APPOINTMENT
export const deleteTokenAppointmentRequest = (id, resolve, reject) => ({
  type: appTypes.DELETE_TOKENAPPOINTMENT_REQUEST,
  payload: { id, resolve, reject },
});

export const deleteTokenAppointmentSuccess = (data) => ({
  type: appTypes.DELETE_TOKENAPPOINTMENT_SUCCESS,
  payload: { data },
});

export const deleteTokenAppointmentFailure = (error) => ({
  type: appTypes.DELETE_TOKENAPPOINTMENT_FAILURE,
  payload: { error },
});



